import React from "react";
import {Form, FormField, TextInput} from "grommet";

const DataTableSearchInput = ({ onChange, value }) => (
    <Form>
        <FormField
            placeholder="Filter by keyword..."
            key="key_search"
            onChange={onChange}
            value={value}
            aria-label="Search Input"
            component={TextInput}
            size="small"
            className="small"
        />
    </Form>
);

export default DataTableSearchInput;